function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBgB = function SvgArrowBgB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m7.72 3.89 15.138 15.137L7.72 34.165l3.665 3.666L30.28 19.027 11.422.17z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgArrowBgB;